<template>
  <div v-if="data != null" class="w-100 text-center dir-ltr d-flex align-start py-2 px-6 flex-wrap">
    <v-card v-if="visible <= data.last_page && hasInput" class="d-flex" flat max-width="200">
      <span class="text-no-wrap me-2 mt-md-3">برو به صفحه:</span>
      <v-text-field v-model="input_model" :max="data.last_page"
                    :messages="`صفحه${data.current_page} از ${data.last_page}`" dense outlined type="number"
                    @keydown.enter="fetch(input_model)"/>
    </v-card>

    <v-card v-if="$slots['per-page'] && (data.last_page >= 2 || data.total >= 10)" flat max-width="150">
      <slot name="per-page"/>
    </v-card>

    <v-spacer/>

    <div>
      <v-btn v-if="data.prev_page_url != null" class="mr-2 my-1 px-2" color="primary lighten-1" min-width="36"
             outlined
             @click="fetch(data.current_page - 1)">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-btn v-if="firstVisible" class="mr-2 my-1 px-2" color="primary lighten-1" min-width="36" outlined
             @click="fetch(1)">
        {{ persian(1) }}
      </v-btn>
      <div v-if="firstDotsVisible" class="h-100 mr-2" style="display: inline">...</div>
      <v-btn v-for="x in computedPaginate" :key="x" :outlined="x !== data.current_page"
             class="mr-2 my-1 px-2" color="primary lighten-1" min-width="36" @click="fetch(x)">
        {{ x }}
      </v-btn>
      <div v-if="lastDotsVisible" class="h-100 mr-2" style="display: inline">...</div>
      <v-btn v-if="lastVisible" class="mr-2 my-1 px-2" color="primary lighten-1" min-width="36" outlined
             @click="fetch(data.last_page)">
        {{ data.last_page }}
      </v-btn>

      <v-btn v-if="data.next_page_url != null" class="mr-2 my-1 px-2" color="primary lighten-1" min-width="36" outlined
             @click="fetch(data.current_page + 1)">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
    </div>

    <v-spacer/>
    <v-spacer/>
  </div>
</template>

<script>
export default {
  name: "pagination",

  props: {
    data: [Array, Object],
    visible: {
      type: Number,
      default: 2
    },
    hasInput: {
      type: Boolean,
      default: true
    }
  },

  data: function () {
    return {
      computedPaginate: [],
      firstVisible: false,
      firstDotsVisible: false,
      lastVisible: false,
      lastDotsVisible: false,
      last_emit: 1,
      input_model: 1
    }
  },

  created: function () {
    this.$emit('page', 1);
    this.setPages()
  },

  watch: {
    data: function () {
      this.setPages()
    }
  },

  methods: {
    setPages() {
      let pages = [];
      let current = this.data.current_page;
      let last = this.data.last_page;
      let visible = this.visible;

      if (this.data.total <= this.data.per_page) {
        this.firstVisible = false;
        this.firstDotsVisible = false;
        this.lastVisible = false;
        this.lastDotsVisible = false;
        this.computedPaginate = [];
        return;
      }

      try {
        if (current <= visible) {
          for (let i = 1; i <= current; i++) {
            if (!this.isInArray(pages, i)) {
              pages.push(i);
            }
          }
        } else {
          for (let i = (current - visible); i <= current; i++) {
            if (!this.isInArray(pages, i)) {
              pages.push(i);
            }
          }
        }
      } catch (exception) {
        console.log(`pagination exception`, exception);
      }

      try {
        if ((current + visible) >= last) {
          let count = last - visible;
          for (let i = (count < 1 ? 1 : count); i <= last; i++) {
            if (!this.isInArray(pages, i)) {
              pages.push(i);
            }
          }
        } else {
          for (let i = current + 1; i <= (current + visible); i++) {
            if (!this.isInArray(pages, i)) {
              pages.push(i);
            }
          }
        }
      } catch (exception) {
        console.log(`pagination exception`, exception);
      }

      try {
        if (!this.isInArray(pages, 2) && last > 2) {
          this.firstVisible = true;
          this.firstDotsVisible = true;
        } else if (!this.isInArray(pages, 1)) {
          this.firstVisible = true;
          this.firstDotsVisible = false;
        } else {
          this.firstVisible = false;
          this.firstDotsVisible = false;
        }
      } catch (exception) {
        console.log(`pagination exception`, exception);
      }

      try {
        if (!this.isInArray(pages, (last - 1)) && (last > 2)) {
          this.lastVisible = true;
          this.lastDotsVisible = true
        } else if (!this.isInArray(pages, last)) {
          this.lastVisible = true;
          this.lastDotsVisible = false;
        } else {
          this.lastVisible = false;
          this.lastDotsVisible = false;
        }
      } catch (exception) {
        console.log(`pagination exception`, exception);
      }

      this.input_model = current
      this.computedPaginate = pages;
    },
    fetch: function (page) {
      if (this.last_emit !== page) {
        if (this.data.last_page < page) {
          this.last_emit = this.data.last_page;
          this.$emit('page', this.data.last_page);
        } else {
          this.last_emit = page;
          this.$emit('page', page);
        }
      }
    },
    isInArray: function (array, value) {
      return array.indexOf(value) > -1;
    },
  }
}

</script>

<style scoped>

</style>